import { useCallback } from 'react';

export const useFakeMutation = () => {
  return useCallback((newRow: any, oldRow: any, schema: any) => {
    const updatedRow = { ...newRow, isNew: false };

    const sendedData: any = {};
    sendedData['originalContent'] = oldRow;
    sendedData['schemaColumns'] = schema?.columns;
    Object.keys(newRow).forEach((dataItem) => {
      if (
        JSON.stringify(oldRow[dataItem]) !== JSON.stringify(newRow[dataItem])
      ) {
        sendedData[dataItem] = newRow[dataItem];
      }
    });

    return new Promise<Partial<any>>((resolve, reject) => {
      schema.client
        .update(newRow['id'] as number, sendedData)
        .then((res: any) => {
          const failedFieldsArray: any = res?.unsaved_fields
            ? { ...res.unsaved_fields }
            : {};

          const refreshTableData = res?.refresh_table;

          const failedFields = Object.keys(failedFieldsArray);

          failedFields.forEach((field) => {
            updatedRow[field] = oldRow[field];
          });

          const updatedRows = res?.updated_rows ? [...res?.updated_rows] : [newRow]
          resolve({ updatedRow, failedFieldsArray, updatedRows, refreshTableData });
        })
        .catch(() => {
          reject(new Error('Error while saving data'));
        });
    });
  }, []);
};